import { useState, useRef, useEffect } from 'react';

const money = (v) => isFinite(v) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(v) : '$0';
const money0 = (v) => isFinite(v) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(v) : '$0';
const num = (s) => { const n = parseFloat(String(s).replace(/[^0-9.]/g, '')); return isFinite(n) ? n : 0; };

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@600;700&family=Fraunces:opsz,wght@9..144,700;9..144,800&family=Inter:wght@400;500;600;700;800&display=swap');
.ir-root{--serif:'Cormorant Garamond',Georgia,serif;--sans:'Inter',-apple-system,system-ui,sans-serif;--bg:linear-gradient(180deg,#f7f2e7,#efe7d6);--card:#fffdf8;--cardEdge:rgba(201,146,42,.26);--ink:#172235;--muted:#7f848b;--line:rgba(23,53,41,.09);--gold:#c9922a;--gold-d:#a9791d;--repBg:#faf6ec;--inputBg:#fff;--investBg:linear-gradient(120deg,#1d3b6c,#0f1f3a);--investInk:#e6bd5c;--investLbl:#f2ecd9;--optHeadBg:linear-gradient(120deg,#1d3b6c,#12233f);--optTitle:#e6bd5c;--payv:#172235;--minus:#a06a2a;font-family:var(--sans);min-height:calc(100vh - 40px);padding:26px 16px;border-radius:20px;background:var(--bg);color:var(--ink);transition:background .35s,color .35s;-webkit-print-color-adjust:exact;print-color-adjust:exact}
.ir-wrap{max-width:840px;margin:0 auto}
.ir-card{background:var(--card);border:1px solid var(--cardEdge);border-radius:26px;box-shadow:0 40px 90px -30px rgba(0,0,0,.55);overflow:hidden}
.ir-toolbar{display:flex;gap:9px;justify-content:space-between;align-items:center;padding:16px 20px 0;flex-wrap:wrap}
.ir-seg{display:inline-flex;background:var(--segBg);border-radius:980px;padding:3px}
.ir-seg button{border:0;background:transparent;color:var(--muted);font-weight:700;font-size:.8rem;padding:7px 14px;border-radius:980px;cursor:pointer;font-family:inherit}
.ir-seg button.ir-on{background:var(--segOn);color:var(--segOnInk)}
.ir-tools{display:flex;gap:9px;align-items:center}
.ir-tbtn{border:0;border-radius:980px;padding:10px 18px;font-weight:600;cursor:pointer;font-size:.9rem;font-family:inherit;transition:.2s;display:inline-flex;align-items:center;gap:6px}
.ir-tbtn:active{transform:scale(.96)}
.ir-tb-present{background:linear-gradient(120deg,var(--gold),var(--gold-d));color:#141b26;font-weight:700}
.ir-tb-print{background:var(--btnBg);color:var(--btnInk);border:1px solid var(--line)}
.ir-tb-music{background:var(--btnBg);border:1px solid var(--line);color:var(--btnInk);width:42px;height:42px;padding:0;justify-content:center;border-radius:50%;font-size:1rem}
.ir-tb-music.ir-on{background:linear-gradient(120deg,var(--gold),var(--gold-d));color:#141b26;border:0}
.ir-head{text-align:center;padding:10px 24px 2px}
.ir-eyebrow{color:var(--gold);font-weight:700;letter-spacing:.32em;font-size:.7rem}
.ir-head h1{font-family:var(--serif);font-weight:700;font-size:2.9rem;margin-top:8px;line-height:1.05;color:var(--ink)}
.ir-tag{color:var(--muted);margin-top:8px;font-style:italic;font-family:var(--serif);font-size:1.15rem}
.ir-body{padding:18px 30px 34px}
.ir-rep{background:var(--repBg);border:1px solid var(--line);border-radius:16px;padding:15px 18px;margin:14px 0 26px}
.ir-toprow{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}
.ir-rep label{font-weight:600;color:var(--ink)}
.ir-badge{border:1px solid var(--gold);color:var(--gold);font-weight:700;font-size:.62rem;letter-spacing:.16em;padding:4px 10px;border-radius:980px}
.ir-m{display:flex;align-items:center;background:var(--inputBg);border:1px solid var(--line);border-radius:12px;padding:9px 14px}
.ir-m span{color:var(--muted);font-size:1.5rem;font-weight:600;margin-right:5px}
.ir-m input{border:0;outline:0;background:transparent;font-size:1.85rem;font-weight:800;color:var(--gold);width:100%;font-family:'Fraunces',Georgia,serif}
.ir-hint{font-size:.78rem;color:var(--muted);margin-top:9px}
.ir-lines{margin-bottom:22px}
.ir-line{display:flex;justify-content:space-between;align-items:center;padding:15px 4px}
.ir-line+.ir-line{border-top:1px solid var(--line)}
.ir-l{display:flex;align-items:center;gap:12px;font-weight:500;font-size:1.06rem}
.ir-chip{border:1.5px solid var(--gold);color:var(--gold);background:transparent;font-weight:700;font-size:.92rem;border-radius:9px;padding:4px 11px}
.ir-chip.ir-tot{background:linear-gradient(135deg,var(--gold),var(--gold-d));color:#141b26;border:0;font-weight:800}
.ir-chip input{width:28px;border:0;background:transparent;color:var(--gold);font:inherit;font-weight:700;text-align:right;outline:0}
.ir-amt{font-family:'Fraunces',Georgia,serif;font-weight:800;font-size:1.2rem;font-variant-numeric:tabular-nums}
.ir-line.ir-msrp .ir-amt{color:var(--muted)}
.ir-line.ir-minus .ir-amt{color:var(--minus)}
.ir-line.ir-total{background:linear-gradient(90deg,rgba(224,178,74,.14),rgba(224,178,74,.04));border-radius:14px;margin-top:10px;padding:16px}
.ir-line.ir-total+.ir-line{border-top:0}
.ir-line.ir-total .ir-amt{color:var(--gold);font-size:1.28rem;font-weight:800}
.ir-invest{display:flex;justify-content:space-between;align-items:center;gap:14px;background:var(--investBg);border:1px solid var(--cardEdge);border-radius:20px;padding:22px 26px;margin-bottom:26px}
.ir-invl{font-size:1.15rem;font-weight:600;color:var(--investLbl)}
.ir-invv{font-family:'Fraunces',Georgia,serif;font-size:2.7rem;font-weight:800;letter-spacing:0;color:var(--investInk);font-variant-numeric:tabular-nums}
.ir-opts{display:grid;grid-template-columns:1fr 1fr;gap:16px}
.ir-opt{border-radius:18px;overflow:hidden;background:var(--repBg);border:1px solid var(--line)}
.ir-opt-h{padding:15px 18px;background:var(--optHeadBg);border-bottom:1px solid var(--cardEdge)}
.ir-opt-t{font-family:var(--serif);font-weight:700;font-size:1.35rem;color:var(--optTitle)}
.ir-opt-s{font-size:.72rem;color:rgba(255,255,255,.7);margin-top:2px;letter-spacing:.06em}
.ir-opt-b{padding:13px 18px 17px}
.ir-pay{display:flex;justify-content:space-between;align-items:center;padding:11px 0}
.ir-pay+.ir-pay{border-top:1px solid var(--line)}
.ir-pk{color:var(--muted);font-weight:500}
.ir-pv{font-family:'Fraunces',Georgia,serif;font-weight:800;font-size:1.22rem;color:var(--payv);font-variant-numeric:tabular-nums}
.ir-pay.ir-big{padding-top:12px}.ir-pay.ir-big .ir-pv{font-size:1.5rem;color:var(--gold)}
.ir-ctrl{display:flex;align-items:center;gap:6px}.ir-ctrl span{color:var(--muted);font-weight:600}
.ir-ctrl input,.ir-ctrl select{border:1px solid var(--line);background:var(--inputBg);border-radius:9px;padding:6px 9px;font:inherit;font-weight:600;width:78px;text-align:right;outline:0;color:var(--ink)}
.ir-ctrl select{width:auto}
.ir-note{font-size:.76rem;color:var(--muted);margin-top:20px;line-height:1.6}
.ir-root.ir-present .ir-no-print{display:none!important}
.ir-root.ir-present input,.ir-root.ir-present select{pointer-events:none;border-color:transparent!important;background:transparent!important}
.ir-root.ir-present .ir-invest{animation:irFade .6s ease .2s both}
@keyframes irFade{0%{opacity:0;transform:translateY(8px)}100%{opacity:1;transform:none}}
.ir-confetti{position:fixed;inset:0;pointer-events:none;z-index:60}
@media(max-width:820px){.ir-body{padding:16px 20px 28px}.ir-head h1{font-size:2.5rem}}
@media(max-width:600px){
  .ir-root{padding:14px 8px;min-height:auto}
  .ir-card{border-radius:20px}
  .ir-toolbar{padding:14px 12px 0;gap:8px;justify-content:center}
  .ir-tbtn{padding:9px 14px;font-size:.84rem}
  .ir-tb-music{width:38px;height:38px}
  .ir-seg button{padding:6px 11px;font-size:.74rem}
  .ir-head{padding:6px 14px 2px}
  .ir-head h1{font-size:1.95rem}
  .ir-tag{font-size:1rem}
  .ir-body{padding:14px 15px 26px}
  .ir-rep{padding:13px 14px}
  .ir-m input{font-size:1.4rem}
  .ir-lines{margin-bottom:16px}
  .ir-line{padding:13px 2px}
  .ir-l{font-size:.97rem;gap:8px;flex-wrap:wrap}
  .ir-amt{font-size:1rem}
  .ir-line.ir-total{padding:13px}
  .ir-line.ir-total .ir-amt{font-size:1.12rem}
  .ir-invest{padding:18px 16px;border-radius:16px}
  .ir-invl{font-size:1rem}
  .ir-invv{font-size:1.65rem}
  .ir-opts{grid-template-columns:1fr}
  .ir-opt-t{font-size:1.2rem}
  .ir-pay.ir-big .ir-pv{font-size:1.28rem}
}
@media(max-width:380px){
  .ir-head h1{font-size:1.65rem}
  .ir-invv{font-size:1.4rem}
  .ir-invl{font-size:.92rem}
  .ir-tbtn{padding:8px 12px;font-size:.8rem}
  .ir-seg button{padding:6px 9px;font-size:.7rem}
  .ir-l{font-size:.92rem}
}
@media print{body *{visibility:hidden!important}.ir-card,.ir-card *{visibility:visible!important}.ir-root{background:none;padding:0}.ir-card{position:absolute;left:0;top:0;width:100%;box-shadow:none}.ir-no-print,.ir-toolbar,.ir-confetti{display:none!important}.ir-ctrl input,.ir-ctrl select,.ir-m input,.ir-chip input{border:0}}
`;


export default function InvestmentReview() {
  const [price, setPrice] = useState('20,000');
  const [pMfg, setPMfg] = useState('10');
  const [pFvb, setPFvb] = useState('15');
  const [cdep, setCdep] = useState('1,000');
  const [dep, setDep] = useState('1,000');
  const [term, setTerm] = useState('60');
  const [apr, setApr] = useState('0');
  const [present, setPresent] = useState(false);
  const [musicOn, setMusicOn] = useState(false);

  const R = {
    msrp: useRef(null), mfg: useRef(null), fvb: useRef(null), saveRow: useRef(null), invest: useRef(null),
    c2: useRef(null), c3: useRef(null), fined: useRef(null), mlabel: useRef(null), monthly: useRef(null),
  };
  const canvasRef = useRef(null);
  const audio = useRef({ ctx: null, music: null, seqTimer: null, on: false });
  const parts = useRef([]); const raf = useRef(null); const vprev = useRef({});

  const compute = () => {
    const P = num(price), pM = num(pMfg), pF = num(pFvb), tot = pM + pF;
    const msrp = tot < 100 ? P / (1 - tot / 100) : P;
    const mfg = msrp * pM / 100, fvb = msrp * pF / 100, save = mfg + fvb;
    const cD = num(cdep), pay30 = P * 0.30, finalP = Math.max(0, P - cD - pay30);
    const fD = num(dep), financed = Math.max(0, P - fD), t = +term || 1, r = num(apr) / 100 / 12;
    const monthly = r > 0 ? financed * r / (1 - Math.pow(1 + r, -t)) : financed / t;
    return { P, msrp, mfg, fvb, save, pay30, finalP, financed, monthly };
  };
  const setNum = (el, key, val, cur0, minus) => { if (!el) return; el.textContent = (minus ? '\u2013 ' : '') + (cur0 ? money0(val) : money(val)); vprev.current[key] = val; };
  const animNum = (el, key, to, cur0, minus) => {
    if (!el) return; const from = vprev.current[key] || 0, t0 = performance.now(), d = 680;
    const step = (t) => { const p = Math.min((t - t0) / d, 1), e = 1 - Math.pow(1 - p, 3), v = from + (to - from) * e;
      el.textContent = (minus ? '\u2013 ' : '') + (cur0 ? money0(v) : money(v)); if (p < 1) requestAnimationFrame(step); else vprev.current[key] = to; };
    requestAnimationFrame(step);
  };
  const paint = (animate) => {
    const v = compute(); const f = animate ? animNum : setNum;
    f(R.msrp.current, 'msrp', v.msrp);
    f(R.mfg.current, 'mfg', v.mfg, false, true);
    f(R.fvb.current, 'fvb', v.fvb, false, true);
    f(R.saveRow.current, 'saveRow', v.save);
    f(R.invest.current, 'invest', v.P, true);
    if (R.c2.current) R.c2.current.textContent = money(v.pay30);
    if (R.c3.current) R.c3.current.textContent = money(v.finalP);
    if (R.fined.current) R.fined.current.textContent = money(v.financed);
    if (R.mlabel.current) R.mlabel.current.textContent = 'Monthly \u00D7' + term;
    if (R.monthly.current) R.monthly.current.textContent = money(v.monthly);
  };

  useEffect(() => {
    const id = 'ah-serif-fonts';
    if (!document.getElementById(id)) {
      const l = document.createElement('link');
      l.id = id; l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@600;700&family=Fraunces:opsz,wght@9..144,700;9..144,800&family=Inter:wght@400;500;600;700;800&display=swap';
      document.head.appendChild(l);
    }
  }, []);

  useEffect(() => { paint(false); });

  useEffect(() => {
    if (present) {
      ['msrp', 'mfg', 'fvb', 'saveRow', 'invest'].forEach(k => { vprev.current[k] = 0; });
      paint(true); confettiBurst(); chime(); if (!audio.current.on) setMusic(true);
    }
  }, [present]);

  useEffect(() => () => { stopMusic(); if (raf.current) cancelAnimationFrame(raf.current); }, []);

  const ensureCtx = () => { const a = audio.current; if (!a.ctx) a.ctx = new (window.AudioContext || window.webkitAudioContext)(); if (a.ctx.state === 'suspended') a.ctx.resume(); };
  const chime = () => { ensureCtx(); const ctx = audio.current.ctx; [523.25, 659.25, 783.99, 1046.5].forEach((fr, i) => { const o = ctx.createOscillator(), g = ctx.createGain(); o.type = 'triangle'; o.frequency.value = fr; const t = ctx.currentTime + i * 0.07; g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(0.14, t + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.6); o.connect(g); g.connect(ctx.destination); o.start(t); o.stop(t + 0.65); }); };
  const mtof = (n) => 440 * Math.pow(2, (n - 69) / 12);
  const voice = (freq, t, gain, type, attack, release) => { const ctx = audio.current.ctx, o = ctx.createOscillator(), g = ctx.createGain(); o.type = type; o.frequency.value = freq; g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(gain, t + attack); g.gain.exponentialRampToValueAtTime(0.0001, t + release); o.connect(g); g.connect(audio.current.music); o.start(t); o.stop(t + release + 0.05); };
  const CH = [[60, 64, 67], [55, 59, 62], [57, 60, 64], [53, 57, 60]], BS = [36, 43, 45, 41], ML = [[72, 76, 79, 76], [74, 79, 83, 79], [72, 76, 81, 76], [69, 72, 77, 81]];
  const barSeq = (t, b, be) => { CH[b].forEach(n => voice(mtof(n), t, 0.045, 'sine', 0.15, be * 4)); voice(mtof(BS[b]), t, 0.13, 'triangle', 0.01, be * 0.9); voice(mtof(BS[b]), t + 2 * be, 0.11, 'triangle', 0.01, be * 0.9); ML[b].forEach((n, i) => voice(mtof(n), t + i * be, 0.11, 'triangle', 0.01, be * 0.75)); };
  const startMusic = () => { ensureCtx(); const ctx = audio.current.ctx; audio.current.music = ctx.createGain(); audio.current.music.gain.value = 0; audio.current.music.connect(ctx.destination); audio.current.music.gain.linearRampToValueAtTime(0.85, ctx.currentTime + 0.25); const bpm = 112, be = 60 / bpm, loop = be * 16; let t = ctx.currentTime + 0.06; audio.current.on = true; const L = () => { if (!audio.current.on) return; for (let b = 0; b < 4; b++) barSeq(t + b * be * 4, b, be); t += loop; audio.current.seqTimer = setTimeout(L, loop * 1000 - 60); }; L(); };
  const stopMusic = () => { const a = audio.current; a.on = false; if (a.seqTimer) { clearTimeout(a.seqTimer); a.seqTimer = null; } if (a.music && a.ctx) a.music.gain.linearRampToValueAtTime(0, a.ctx.currentTime + 0.4); };
  const setMusic = (on) => { ensureCtx(); if (on) { startMusic(); setMusicOn(true); } else { stopMusic(); setMusicOn(false); } };
  const toggleMusic = () => setMusic(!audio.current.on);

  const confettiBurst = () => {
    const cv = canvasRef.current; if (!cv) return; cv.width = window.innerWidth; cv.height = window.innerHeight;
    const cols = ['#e6bd5c', '#c9922a', '#f6dd9b', '#1d3b6c', '#2c456c', '#f0c860'];
    for (let i = 0; i < 120; i++) parts.current.push({ x: window.innerWidth / 2 + (Math.random() - .5) * 200, y: window.innerHeight * 0.3, vx: (Math.random() - .5) * 9, vy: Math.random() * -9 - 3, g: 0.22, r: Math.random() * 6 + 3, c: cols[i % cols.length], a: 1, rot: Math.random() * 6, vr: (Math.random() - .5) * .3 });
    if (!raf.current) raf.current = requestAnimationFrame(tick);
  };
  const tick = () => {
    const cv = canvasRef.current; if (!cv) { raf.current = null; return; } const cx = cv.getContext('2d');
    cx.clearRect(0, 0, cv.width, cv.height);
    parts.current.forEach(p => { p.vy += p.g; p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.a -= 0.006; cx.save(); cx.globalAlpha = Math.max(0, p.a); cx.translate(p.x, p.y); cx.rotate(p.rot); cx.fillStyle = p.c; cx.fillRect(-p.r / 2, -p.r / 2, p.r, p.r * 1.6); cx.restore(); });
    parts.current = parts.current.filter(p => p.a > 0 && p.y < cv.height + 40);
    raf.current = parts.current.length ? requestAnimationFrame(tick) : null;
  };

  const totalPct = (num(pMfg) + num(pFvb)) || 0;

  return (
    <>
      <style>{CSS}</style>
      <canvas ref={canvasRef} className="ir-confetti" />
      <div className={`ir-root${present ? ' ir-present' : ''}`}>
        <div className="ir-wrap"><div className="ir-card">
          <div className="ir-toolbar">
            <div className="ir-tools">
              <button className={`ir-tbtn ir-tb-music${musicOn ? ' ir-on' : ''}`} title="Music" onClick={toggleMusic}>{musicOn ? '\uD83D\uDD0A' : '\uD83D\uDD08'}</button>
              <button className="ir-tbtn ir-tb-present" onClick={() => setPresent(p => !p)}>{present ? 'Back to edit' : 'Present to customer'}</button>
              <button className="ir-tbtn ir-tb-print" onClick={() => window.print()}>Print</button>
            </div>
          </div>
          <div className="ir-head">
            <div className="ir-eyebrow">AMANDA'S HOME IMPROVEMENT</div>
            <h1>Your Investment Review</h1>
            <div className="ir-tag">Your exclusive savings, prepared just for today.</div>
          </div>
          <div className="ir-body">
            <div className="ir-rep ir-no-print">
              <div className="ir-toprow"><label>Project Price</label><span className="ir-badge">REP ONLY</span></div>
              <div className="ir-m"><span>$</span>
                <input value={price} inputMode="decimal" onChange={e => setPrice(e.target.value)}
                  onBlur={() => setPrice(num(price) ? num(price).toLocaleString('en-US') : '')} />
              </div>
              <div className="ir-hint">Enter your sell price — everything below fills in automatically (price ÷ 0.75).</div>
            </div>

            <div className="ir-lines">
              <div className="ir-line ir-msrp"><div className="ir-l">Original Price</div><div className="ir-amt" ref={R.msrp}>$0</div></div>
              <div className="ir-line ir-minus"><div className="ir-l">Manufacturer's Discount <span className="ir-chip"><input value={pMfg} onChange={e => setPMfg(e.target.value)} />%</span></div><div className="ir-amt" ref={R.mfg}>$0</div></div>
              <div className="ir-line ir-minus"><div className="ir-l">First Visit Bonus <span className="ir-chip"><input value={pFvb} onChange={e => setPFvb(e.target.value)} />%</span></div><div className="ir-amt" ref={R.fvb}>$0</div></div>
              <div className="ir-line ir-total"><div className="ir-l">Today's Total Savings <span className="ir-chip ir-tot">{totalPct}%</span></div><div className="ir-amt" ref={R.saveRow}>$0</div></div>
            </div>

            <div className="ir-invest"><div className="ir-invl">Your Investment Today</div><div className="ir-invv" ref={R.invest}>$0</div></div>

            <div className="ir-opts">
              <div className="ir-opt ir-cash">
                <div className="ir-opt-h"><div className="ir-opt-t">Pay in Full</div><div className="ir-opt-s">CASH · CHECK · CREDIT CARD</div></div>
                <div className="ir-opt-b">
                  <div className="ir-pay"><div className="ir-pk">Deposit</div><div className="ir-ctrl"><span>$</span><input value={cdep} onChange={e => setCdep(e.target.value)} /></div></div>
                  <div className="ir-pay"><div className="ir-pk">30% Payment</div><div className="ir-pv" ref={R.c2}>$0</div></div>
                  <div className="ir-pay ir-big"><div className="ir-pk">Final Payment</div><div className="ir-pv" ref={R.c3}>$0</div></div>
                </div>
              </div>
              <div className="ir-opt ir-fin">
                <div className="ir-opt-h"><div className="ir-opt-t">Monthly Plan</div><div className="ir-opt-s">EASY MONTHLY INSTALLMENTS</div></div>
                <div className="ir-opt-b">
                  <div className="ir-pay"><div className="ir-pk">Deposit</div><div className="ir-ctrl"><span>$</span><input value={dep} onChange={e => setDep(e.target.value)} /></div></div>
                  <div className="ir-pay ir-no-print"><div className="ir-pk">Term / APR</div><div className="ir-ctrl">
                    <select value={term} onChange={e => setTerm(e.target.value)}>{[12, 24, 36, 48, 60, 120].map(m => <option key={m} value={m}>{m}</option>)}</select>
                    <input value={apr} onChange={e => setApr(e.target.value)} /><span>%</span>
                  </div></div>
                  <div className="ir-pay"><div className="ir-pk">Amount Financed</div><div className="ir-pv" ref={R.fined}>$0</div></div>
                  <div className="ir-pay ir-big"><div className="ir-pk" ref={R.mlabel}>Monthly</div><div className="ir-pv" ref={R.monthly}>$0</div></div>
                </div>
              </div>
            </div>
            <div className="ir-note ir-no-print">Cash: $1,000 deposit (editable), then 30% of the project, and the final payment is the remaining balance. Financing is third-party — enter the lender's term &amp; APR to preview a monthly; the lender's approved quote is final.</div>
          </div>
        </div></div>
      </div>
    </>
  );
}
